import { cachePathway } from './pathwayProfile'

import * as h2Api from '../h2Api'
import { browserHistory } from '../Routes'

export const PROFILER_SELECT_CHOICE = 'PROFILER_SELECT_CHOICE'
export const PROFILER_MOVE = 'PROFILER_MOVE'
export const PROFILER_SAVE = 'PROFILER_SAVE'
export const PROFILER_LOAD = 'PROFILER_LOAD'
export const PROFILER_RESET = 'PROFILER_RESET'
export const PROFILER_SCORE = 'PROFILER_SCORE'

const saveQuestionnaire = () => (dispatch, getState) => {
  if (!dynamicValues.userProfile) {
    return
  }

  const interestProfilerState = getState().early.interestActivity
  const profilerAnswers = JSON.stringify(interestProfilerState.answers)
  const isCompleted = interestProfilerState.completedAt != null
  const loadedGameId = getState().early.gameboard.loadedGameId

  h2Api.put(`/early/${loadedGameId}/interests/save`, {
    answers: profilerAnswers,
    isComplete: isCompleted
  })({ type: PROFILER_SAVE })(dispatch)
}

export const selectQuestionChoice = (choice, question) => (dispatch, getState) => {
  dispatch({ type: PROFILER_SELECT_CHOICE, choice, question })
  dispatch(saveQuestionnaire())
  const questionIndex = getState().early.interestActivity.currentQuestionIndex
  const page =
    getState().early.interestActivity.metaData.questions.length > questionIndex
      ? questionIndex
      : 'summarize'
  const loadedGameId = getState().early.gameboard.loadedGameId

  browserHistory.push(`/early/game/${loadedGameId}/interests/${page}`)
}

export const score = () => (dispatch, getState) => {
  //console.log(getState())
  const interestProfilerState = getState().early.interestActivity
  const loadedGameId = getState().early.gameboard.loadedGameId

  dispatch(
    h2Api.post(`/early/${loadedGameId}/interests/score`, {
      answers: interestProfilerState.answers
    })({ type: PROFILER_SCORE })
  ).then(r => {
    r.forEach(p => dispatch(cachePathway(p)))
  })
}

export const move = questionIndex => (dispatch, getState) => {
  //console.log(getState().early.interestActivity.currentQuestionIndex)
  dispatch({ type: PROFILER_MOVE, questionIndex })
  //console.log(getState().early.interestActivity.currentQuestionIndex)
  const loadedGameId = getState().early.gameboard.loadedGameId
  const page =
    getState().early.interestActivity.metaData.questions.length > questionIndex
      ? questionIndex
      : 'summarize'

  browserHistory.push(`/early/game/${loadedGameId}/interests/${page}`)
}

export const loadQuestionnaire = questionId => dispatch => {
  console.log('getting', questionId)

  return Promise.resolve(dispatch({ type: PROFILER_LOAD, selected: questionId }))
}

export const redoQuestionaire = () => (dispatch, getState) => {
  if (!dynamicValues.userProfile) {
    dispatch({ type: PROFILER_RESET })
    browserHistory.push('/early/interests')
  } else {
    const loadedGameId = getState().early.gameboard.loadedGameId

    h2Api
      .put(
        `/early/${loadedGameId}/interests/reset`,
        {}
      )({ type: PROFILER_RESET })(dispatch)
      .then(() => {
        const loadedGameId = getState().early.gameboard.loadedGameId

        browserHistory.push(`/early/game/${loadedGameId}/interests`)
      })
  }
}

export const summarizeResponses = mp => {
  if (!mp) {
    return {}
  }

  console.log(Object.keys(mp))
  const itms = Object.keys(mp)
    .map(function (key) {
      return mp[key]
    })
    .reduce(function (grouped, item) {
      const key = item

      grouped[key] = (grouped[key] || 0) + 1

      return grouped
    }, {})

  console.log(itms)
  const m2 = Object.keys(itms).map(function (key) {
    return { interest: key, score: itms[key] }
  })

  console.log(m2)

  return m2
}
